
import Vue from "vue";
import WJsonViewerEntry from "./JsonViewerEntry.vue";
import WJsonViewerWrapper from "./JsonViewerWrapper.vue";
import WJsonViewerKey from "./JsonViewerKey.vue";

export default Vue.extend({
	name: "WJsonViewerGroup",
	data(){
		return {
			opened: false
		};
	},
	props: {
		value: {
			type: [Object, Array],
			required: true
		},
		keyName: {
			type: String
		},
		open: Boolean,
		isLastItem: Boolean,
		hideKey: Boolean,
		isRoot: Boolean
	},
	computed: {
		isArray():boolean {
			return Array.isArray(this.value);
		},
		keys():string[]{
			return Object.keys(this.value);
		},
		openingTag():string{
			if (this.isArray) {
				return "[";
			}
			return "{";
		},
		closingTag():string {
			if (this.isArray){
				return "]";
			}
			return "}";
		},
		isOpen():boolean {
			return  this.open && this.opened;
		},
		openIcon(){
			if (this.opened) {
				return "caret-down";
			}
			return "caret-right";
		},
		isRootElement():boolean {
			return !this.keyName;
		}
	},
	methods: {
		hideValue(value:any):boolean {
			return typeof(value) == "function";
		},
		isValueGroup(value:any):boolean{
			return typeof(value) == "object" && !(value instanceof Date) && value !== null;
		},
		isLastKey(value:string):boolean {
			return this.keys.indexOf(value) == (this.keys.length-1);
		},
		toggleOpen(){
			this.opened = !this.opened;
		}
	},
	mounted(){
		if (this.isRoot) {
			this.opened = true;
		}
	},
	components: {
		WJsonViewerEntry,
		WJsonViewerWrapper,
		WJsonViewerKey
	}
});
